/* eslint-disable react/prop-types */
import React from "react";
import Container from "./Container";
import { CriteriaWidget, OneFeedWidget, LiveClientFeed, SignalConvergenceEngine } from "./Infographic";

const Benefits = (props) => {
  const { data } = props;
  const infographic =
    data.infographic === "criteria" ? (
      <CriteriaWidget />
    ) : data.infographic === "convergence" ? (
      <SignalConvergenceEngine />
    ) : data.infographic === "onefeed" ? (
      <OneFeedWidget />
    ) : data.infographic === "clientfeed" ? (
      <LiveClientFeed />
    ) : null;

  return (
    <>
      <Container className="flex flex-wrap gap-10 py-10 lg:py-14 lg:flex-nowrap lg:gap-16">
        <div
          className={`flex items-center justify-center w-full lg:w-1/2 ${
            props.imgPos === "right" ? "lg:order-1" : ""
          }`}
        >
          <div className={`w-full ${data.infographic === "clientfeed" ? "max-w-[520px]" : data.infographic === "convergence" ? "max-w-xl" : "max-w-md"}`}>
            {infographic}
          </div>
        </div>

        <div
          className={`flex flex-wrap items-center w-full lg:w-1/2 ${
            props.imgPos === "right" ? "lg:justify-end" : ""
          }`}
        >
          <div className="w-full max-w-xl">
            <h3 className="text-2xl font-bold leading-tight tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
              {data.title}
            </h3>

            {data.desc && (
              <p className="mt-3 text-base leading-relaxed text-slate-600 lg:text-lg">
                {data.desc}
              </p>
            )}

            <div className="mt-6">
              {data.bullets.map((item, index) => (
                <Benefit key={index} title={item.title} icon={item.icon}>
                  {item.desc}
                </Benefit>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

function Benefit(props) {
  return (
    <div className="flex items-start gap-4 mt-6 first:mt-0">
      <div className="flex flex-shrink-0 items-center justify-center h-10 w-10 rounded-lg bg-emerald-100 text-emerald-600">
        {React.cloneElement(props.icon, { className: "h-5 w-5" })}
      </div>
      <div>
        <h4 className="text-base font-semibold text-slate-900 sm:text-lg">
          {props.title}
        </h4>
        <p className="mt-1 text-sm leading-relaxed text-slate-600 sm:text-base">
          {props.children}
        </p>
      </div>
    </div>
  );
}

export default Benefits;
